import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { QueryResponse } from '../../core/services/QueryResponse';
import { ModelResponse } from '../../core/services/ModelResponse';
import { ExtractModel } from "../models/ExtractModel";
import { ExtractListModel } from "../models/ExtractListModel";
import { OptionModel } from "../models/OptionModel";
import { ExtractPageViewModel } from "../models/ExtractPageViewModel";
import { CalOmsExtractWorkspaceModel } from "../models/CalOmsExtractWorkspaceModel";
import { CalOmsExtractWorkspaceFilterModel } from "../models/CalOmsExtractWorkspaceFilterModel";

@Injectable()
export class ExtractsService {
  constructor(public httpClient: HttpClient) { }

  getExtractCategoryList(page: number, pageSize: number, sort: string, sortDirection: string, searchTerm: string): Observable<QueryResponse<ExtractModel>> {
    var params = new HttpParams()
      .set('skip', (page * pageSize).toString())
      .set('take', pageSize.toString());
    if (sort) {
      params = params.set('sort', sort)
        .set('sortDirection', sortDirection);
    }
    if (searchTerm) {
      params = params.set('searchTerm', searchTerm);
    }
    return this.httpClient.get<QueryResponse<ExtractModel>>("/api/ExtractsModule/ExtractCategories/ListQuery", { params: params });
  }

  getExtractList( page: number, pageSize: number, sort: string, sortDirection: string, searchTerm: string, model: ExtractModel = null ): Observable<QueryResponse<ExtractListModel>> {
    var extractPageViewModel = new ExtractPageViewModel();
    extractPageViewModel.page = page;
    extractPageViewModel.pageSize = pageSize;
    extractPageViewModel.skip = page * pageSize;
    extractPageViewModel.take = pageSize;
    extractPageViewModel.sort = sort;
    extractPageViewModel.sortDirection = sortDirection;
    extractPageViewModel.searchTerm = searchTerm;
    if (model != null) {
      extractPageViewModel.model = model;
    }
    return this.httpClient.post<QueryResponse<ExtractListModel>>("/api/ExtractsModule/Extracts/ListQuery", extractPageViewModel);
  }

  getExtractWorkspaceList(key: string, page: number, pageSize: number, sort: string, sortDirection: string, searchTerm: string, extractType: string, model: ExtractModel = null, filterModel: CalOmsExtractWorkspaceFilterModel = null): Observable<QueryResponse<CalOmsExtractWorkspaceModel>> {
    var extractPageViewModel = new ExtractPageViewModel();
    extractPageViewModel.page = page;
    extractPageViewModel.pageSize = pageSize;
    extractPageViewModel.skip = page * pageSize;
    extractPageViewModel.take = pageSize;
    extractPageViewModel.sort = sort;
    extractPageViewModel.sortDirection = sortDirection;
    extractPageViewModel.searchTerm = searchTerm;
    extractPageViewModel.extractType = extractType;
    if (model != null) {
      extractPageViewModel.model = model;
    }
    if (filterModel != null) {
      extractPageViewModel.filterModel = filterModel;
    }
    return this.httpClient.post<QueryResponse<CalOmsExtractWorkspaceModel>>(`/api/ExtractsModule/Extracts/WorkSpaceListQuery/${key}`, extractPageViewModel);
  }

  finalizeExtract( extractKey: string, model: ExtractModel ): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>(`/api/ExtractsModule/${extractKey}/Finalize/`, { model: model });
  }

  deleteExtract(extractKey: string, model: ExtractModel): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>(`/api/ExtractsModule/${extractKey}/Delete/`, { model: model });
  }

  generateExtract(model: ExtractPageViewModel): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>(`/api/ExtractsModule/GenerateExtract/`, { model: model });
  }

  generateChildExtracts(extractKey: string, model: ExtractModel): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>(`/api/ExtractsModule/${extractKey}/GenerateChildExtracts/`, { model: model });
  }

  saveExtract(models: CalOmsExtractWorkspaceModel[]): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>(`/api/ExtractsModule/Save/`, { model: models });
  }
}



// WEBPACK FOOTER //
// ./src/app/extracts/services/ExtractsService.ts